// extracted by mini-css-extract-plugin
module.exports = {"footer_contact":"FooterContact_footer_contact_2ZWSX"};